import React, { useState } from "react";
import {
  IonContent,
  IonPage,
  IonButton,
  IonInput,
  IonLoading,
  IonAlert,
} from "@ionic/react";
import { useAuthStore } from "@/store/authStore";
import api from "@/services/api";
import { setStoredLanguage, useI18n } from "@/i18n";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuthStore();
  const { t } = useI18n();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await api.post("/api/auth/login", { username, password });
      const { player, token } = response.data;
      login(player, token);
      if (player?.preferredLanguage) setStoredLanguage(player.preferredLanguage);
      window.location.href = "/";
    } catch (err: any) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        {/* Green header strip */}
        <div className="hero-section" style={{ padding: "32px 24px 24px" }}>
          <h1>{t("appTitle")}</h1>
        </div>

        <div className="auth-form">
          <h2>{t("loginTitle")}</h2>
          <form onSubmit={handleLogin}>
            <IonInput
              type="text"
              label={t("loginUsernameLabel")}
              labelPlacement="stacked"
              fill="outline"
              value={username}
              onIonInput={(e) => setUsername(e.detail.value!)}
              required
              style={{ marginBottom: "16px", "--border-radius": "8px" }}
            />
            <IonInput
              type="password"
              label={t("loginPasswordLabel")}
              labelPlacement="stacked"
              fill="outline"
              value={password}
              onIonInput={(e) => setPassword(e.detail.value!)}
              required
              style={{ marginBottom: "24px", "--border-radius": "8px" }}
            />
            <IonButton
              expand="block"
              type="submit"
              disabled={loading}
              className="save-btn"
              style={{ "--border-radius": "10px" }}
            >
              {loading ? t("loginLoading") : t("loginButton")}
            </IonButton>
          </form>

          <IonButton
            expand="block"
            fill="clear"
            size="small"
            routerLink="/register"
            routerDirection="forward"
            style={{ marginTop: "12px" }}
          >
            {t("loginNoAccount")}
          </IonButton>
          <IonButton
            expand="block"
            fill="clear"
            size="small"
            routerLink="/how-it-works"
            routerDirection="forward"
          >
            {t("howItWorksNav")}
          </IonButton>
        </div>

        <IonLoading isOpen={loading} message={t("loginLoading")} />
        <IonAlert
          isOpen={!!error}
          onDidDismiss={() => setError("")}
          header={t("errorTitle")}
          message={error}
          buttons={[t("okButton")]}
        />
      </IonContent>
    </IonPage>
  );
};

export default Login;
